// extracted by mini-css-extract-plugin
module.exports = {"signUpSection":"SeoSignup_signUpSection__3pMWw","title":"SeoSignup_title__39TBJ","subTitle":"SeoSignup_subTitle__wARgn"};